import React from 'react';
import { useTrackSection } from '../utils/useTrackSection';
const bonuses = [{
  num: '01',
  emoji: '❓',
  title: 'Preguntas que Deciden',
  desc: 'Preguntas situacionales para conducir la consulta y cerrar con compromiso operativo.',
  price: '$12.000'
}, {
  num: '02',
  emoji: '⚠️',
  title: 'Los 6 Errores Más Caros',
  desc: 'Prioridades difusas, plan que no encaja, seguimiento superficial y procesos que nunca cierran.',
  price: '$9.000'
}, {
  num: '03',
  emoji: '🧩',
  title: 'Perfiles Complejos',
  desc: 'Leer patrones sin etiquetar y adaptar la intervención al problema real del paciente.',
  price: '$10.000'
}, {
  num: '04',
  emoji: '🎯',
  title: 'Objetivos que se Cumplen',
  desc: 'Del "quiero" al "hago esto, así". Objetivos claros, conectados a la rutina y seguibles.',
  price: '$9.000'
}, {
  num: '05',
  emoji: '📊',
  title: 'Seguimiento Profundo',
  desc: 'Leer evolución más allá del peso y detectar abandono silencioso a tiempo.',
  price: '$8.000'
}, {
  num: '06',
  emoji: '💼',
  title: 'Presencia Profesional',
  desc: 'Consultas con foco, escucha real y una sola prioridad clara al cierre.',
  price: '$10.000'
}];
export function WhatYouGet() {
  useTrackSection('what-you-get', 'What You Get Section');
  return <section id="what-you-get" className="w-full px-4 sm:px-6 lg:px-8 py-10 text-gray-900" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(240,253,244) 0%, rgb(240,253,244) 50%, rgb(248,250,252) 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-364">
      <div className="mx-auto max-w-4xl" data-id="element-365">

        {/* Heading */}
        <h2 className="text-2xl font-black text-center text-gray-900 m-0 mb-2" data-id="element-366">
          Más los{' '}
          <span className="text-green-700" data-id="element-367">6 Bonos de Autoridad Profesional</span>
        </h2>
        <p className="text-center text-sm text-gray-500 m-0 mb-8" data-id="element-368">
          Resuelven lo que ningún tomo clínico cubre — incluidos en todas las ofertas
        </p>

        {/* Bonus list */}
        <div className="bg-white rounded-xl overflow-hidden shadow-sm mb-6" style={{
        border: '1px solid rgba(34,197,94,0.20)'
      }} data-id="element-369">
          <div className="px-5 py-3 bg-green-700" data-id="element-370">
            <h3 className="text-sm font-black text-white m-0" data-id="element-371">
              🎁 LOS 6 BONOS — Incluidos siempre
            </h3>
          </div>
          <div className="divide-y divide-gray-100" data-id="element-372">
            {bonuses.map(bonus => <div key={bonus.num} className="flex items-center gap-4 px-5 py-3" data-id="element-373">
                <span className="shrink-0 text-xl w-8 text-center" data-id="element-374">
                  {bonus.emoji}
                </span>
                <div className="flex-1 min-w-0" data-id="element-375">
                  <span className="block text-sm font-black text-gray-900" data-id="element-376">
                    {bonus.title}
                  </span>
                  <span className="block text-xs text-gray-500 mt-0.5" data-id="element-377">
                    {bonus.desc}
                  </span>
                </div>
                <div className="shrink-0 flex flex-col items-center gap-1 min-w-[64px]" data-id="element-378">
                  <span className="text-xs font-bold text-gray-400 line-through" data-id="element-379">
                    {bonus.price}
                  </span>
                  <span className="text-[11px] font-black text-white rounded-full px-3 py-1 text-center" style={{
                backgroundColor: 'rgb(21,128,61)'
              }} data-id="element-380">
                    GRATIS
                  </span>
                </div>
              </div>)}
          </div>
        </div>

        {/* Total value */}
        <div className="text-center rounded-xl px-5 py-4" style={{
        backgroundColor: 'rgba(34,197,94,0.05)',
        border: '1px solid rgba(34,197,94,0.20)'
      }} data-id="element-381">
          <p className="text-xs font-bold uppercase tracking-widest m-0 mb-1" style={{
          color: 'rgb(21,128,61)'
        }} data-id="element-382">
            Valor total de los 6 Bonos
          </p>
          <div className="flex items-center justify-center gap-3" data-id="element-383">
            <span className="text-base text-gray-400 line-through" data-id="element-384">$58.000</span>
            <span className="text-lg font-black" style={{
            color: 'rgb(21,128,61)'
          }} data-id="element-385">
              🎁 GRATIS — Incluidos siempre
            </span>
          </div>
        </div>

      </div>
    </section>;
}